export const STRINGS = {
  SEARCH_PLACEHOLDER: "Search",
  EMPTY: "",
  TOOLTIP_PROVIDER_LINK: "View Provider Details",
  TOOLTIP_CLIENT_LINK: "Go to Case Detail",
};

export const UI_STATES = {
  LOADING: "LOADING",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
  INITIAL: "INITIAL",
};
